var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#E03137",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E03137",
    d: "M 26 10 c -8.822 0 -16 7.178 -16 16 s 7.178 16 16 16 s 16 -7.178 16 -16 s -7.178 -16 -16 -16 z m 0 25.334 a 1.334 1.334 90 1 1 0 -2.668 a 1.334 1.334 90 0 1 0 2.668 z m 1.334 -6.668 a 1.334 1.334 90 1 1 -2.668 0 V 24 a 1.334 1.334 90 0 1 2.668 0 z",
    opacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCross);
export default __webpack_public_path__ + "static/media/error_cross.9b2775964c03cd12d985b0d1fde0bab0.svg";
export { ForwardRef as ReactComponent };